import { createContext, type ReactNode, useContext } from 'react';
import { getConfig } from '../get-config';
import { type ResolvedTenant, resolveTenant } from '../types';
import { getWhitelabelHost } from './host';

const TenantContext = createContext<ResolvedTenant>(resolveTenant());

/** Resolve once per page load; the hostname cannot change under a SPA. */
export function currentTenant(): ResolvedTenant {
  return resolveTenant(getConfig(getWhitelabelHost()));
}

export function TenantProvider({
  tenant,
  children,
}: {
  tenant: ResolvedTenant;
  children: ReactNode;
}): ReactNode {
  return <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>;
}

export function useTenant(): ResolvedTenant {
  return useContext(TenantContext);
}
